var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploaded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "#005AA7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95711 8.29289C9.56658 7.90237 8.93342 7.90237 8.54289 8.29289L4.54289 12.2929C4.15237 12.6834 4.15237 13.3166 4.54289 13.7071C4.93342 14.0976 5.56658 14.0976 5.95711 13.7071L8.25 11.4142V21C8.25 22.3261 8.77678 23.5979 9.71447 24.5355C10.6521 25.4732 11.9239 26 13.25 26H18.25C18.8023 26 19.25 25.5523 19.25 25C19.25 24.4477 18.8023 24 18.25 24H13.25C12.4544 24 11.6913 23.6839 11.1287 23.1213C10.5661 22.5587 10.25 21.7956 10.25 21V11.4142L12.5429 13.7071C12.9334 14.0976 13.5666 14.0976 13.9571 13.7071C14.3476 13.3166 14.3476 12.6834 13.9571 12.2929L9.95711 8.29289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7075 12.5818C29.0978 12.191 29.0975 11.5579 28.7068 11.1675C28.316 10.7772 27.6829 10.7775 27.2925 11.1682L19.9996 18.4704L16.7071 15.1779C16.3166 14.7874 15.6834 14.7874 15.2929 15.1779C14.9024 15.5684 14.9024 16.2016 15.2929 16.5921L19.2929 20.5921C19.4805 20.7797 19.7349 20.8851 20.0002 20.885C20.2656 20.8849 20.52 20.7794 20.7075 20.5918L28.7075 12.5818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploaded);
export default __webpack_public_path__ + "static/media/file-uploaded.11b9ca466054c20758ab8f86b8015e71.svg";
export { ForwardRef as ReactComponent };